import { combineReducers } from "@reduxjs/toolkit";
import isAuth from "./isAuthRequest";
import isSubmitting from "./isSubmittingRequest";
import isFrogot from "./isSubmittingRequest";
import setting from "./settingReducer";
import steps_labels from "./stepLabelReducer";
import brand from "./brandReducer";
import homePageData from "./homePageReducers";
import testimonials from "./testimonialsReducer";
import community from "./communityReducer";
import ResourcesHubData from "./resourceHubReducer";
import pagination from "./paginationReducers";

// Redux Toolkit Slices
import aboutUsReducer from "../Pages/AboutUs/Slice/aboutUsSlice";
import settingsReducer from "../store/slices/settingsSlice";
import certificateReducer from "../Pages/Certificate/Slice/certificateSlice";
import contactUsReducer from "../Pages/ContactUs/Slice/contactUsSlice";
import deleteProfileReducer from "../Pages/DeleteProfile/Slice/deleteProfileSlice";
import eventDetailReducer from "../Pages/Event/Slice/eventDetailSlice";
import eventsReducer from "../Pages/Event/Slice/eventSlice";
import faqReducer from "../Pages/Faq/Slice/faqSlice";
import answerReducer from "../Pages/Forum/Slice/answerSlice";
import questionReducer from "../Pages/Forum/Slice/questionSlice";
import reportAdminReducer from "../Pages/Forum/Slice/reportAdminSlice";
import reportUserReducer from "../Pages/Forum/Slice/reportUserSlice";
import forumReducer from "../Pages/Forum/Slice/forumSlice";

import isFetching from "./networkRequest";
import faqData from "./faqDataReducer";
import userExperience from "./experienceUserReducer";
import filter from "./filterReducer";
import redirectTo from "./redirectTo";
import userInfo from "./userInfoReducer";
import updateProfileData from "./updateProfileDataReducer";
import userRegister from "./registerDataReducer";
import mentorsData from "./mentorDataReducer";
import menteeRequestData from "./menteeRequestDataReducer";
import myWaitListData from "./myWaitListReducer";
import categories from "./categoriesReducer";
import forums from "./forumReducer";
import forumusers from "./forumUserReducer";
import reportcategories from "./reportCategoriesReducer";
import scheduleListingReducer from "./scheduleReducer";

import eventsData from "./eventsReducer";
import NewsletterData from "./newsletterReducer";
import VideoData from "./videoReducer";
import programmes from "./programmesReducer";
import categoryUserReducer from "./categoryUserReducers";
import teamsReducer from "./teamsReducer";
import advisorsReducer from "./advisorsReducer";
import buttonReducer from "../Component/Button/Slice/buttonSlice";
import footerReducer from "../Component/Footer/Slice/footerSlice";
import forgotPasswordReducer from "../Pages/Authentication/ForgotPassword/Slice/forgotPasswordSlice";
import userReducer from "../store/slices/userSlice";
import resetPasswordReducer from "../Pages/Authentication/RestPassword/Slice/resetPasswordSlice";
import signInReducer from "../Pages/Authentication/SignIn/Slice/signInSlice";
import availabilityReducer from "../Pages/Availability/Slice/availabilitySlice";
import chatReducer from "../Pages/Chat/Slice/ChatSlice";
import cmsReducer from "../Pages/CMS/Slice/cmsSlice";
import communityauthReducer from "../Pages/CommunityDetail/Slice/communityauthSlice";
import communityDetailReducer from "../Pages/CommunityDetail/Slice/communityDetailSlice";
import dashboardMentorReducer from "../Pages/DashboardMentor/Slice/dashboardMentorSlice";
import menteeDashboardReducer from "../Pages/MenteeDashboard/Slice/MenteeDashboardSlice";
import menteeListingReducer from "../Pages/MenteeListing/Slice/menteeListingSlice";
import menteesLogReducer from "../Pages/MenteesLog/Slice/menteesLogSlice";
import menteesRequestReducer from "../Pages/MenteesRequest/Slice/menteesRequestSlice";
import mentorDashboard1Reducer from "../Pages/MentorDashboard1/Slice/mentorDashboard1Slice";
import mentorIgniteReducer from "../Pages/MentorIgnite/Slice/mentorIgniteSlice";
import mentorsReducer from "../Pages/Mentors/Slice/mentorsSlice";
import myDiagnosticToolkitReducer from "../Pages/MyDiagnosticToolkit/Slice/myDiagnosticToolkitSlice";
import myWaitListReducer from "../Pages/MyWaitList/Slice/myWaitListSlice";
import organisationReducer from "../Pages/Organisation/Slice/organisationSlice";
import passwordReducer from "../Pages/Password/Slice/passwordSlice";
import pendingMenterRequestReducer from "../Pages/PendingMenterRequest/Slice/pendingMenterRequestSlice";
import preregisterationFormReducer from "../Pages/PreRegistrationFrom/Slice/preRegistrationFormSlice";
import programReducer from "../Pages/Program/Slice/programSlice";
import referReducer from "../Pages/Refer/Slice/referSlice";
import resourcesHubReducer from "../Pages/Resourcehub/Slice/resourcesHubSlice";
import newsletterReducer from "../Pages/Resourcehub/Slice/newsletterSlice";
import scheduleListingCalendarReducer from "../Pages/ScheduleListingCalendar/Slice/scheduleListingCalendarSlice";
import pageReducer from "../Pages/Slice/pageSlice";
import updateProfile1Reducer from "../Pages/UpdateProfile/Slice/updateProfile1Slice";
import updateProfile4Reducer from "../Pages/UpdateProfile/Slice/updateProfile4Slice";
import updateProfileStep1Reducer from "../Pages/UpdateProfile/Slice/updateProfileStep1Slice";
import myMentorsReducer from "../Pages/MyMentors/Slice/myMentorsSlice";
import homeReducer from "../Pages/Home/Slice/homeSlice";
import registerReducer from "../Pages/Authentication/Register/slice/registerSlice";
import updateProfileReducer from "../Pages/UpdateProfile/Slice/updateProfileSliceNew";




const appReducer = combineReducers({
  register: registerReducer,
  updateProfile: updateProfileReducer,
  isAuth,
  isSubmitting,
  isFrogot,
  pagination,
  setting,
  steps_labels,
  brand,
  homePageData,
  // Redux Toolkit Slices
  button: buttonReducer,
  footer: footerReducer,
  forgotPassword: forgotPasswordReducer,
  aboutUs: aboutUsReducer,
  settings: settingsReducer,
  user: userReducer,
  resetPassword: resetPasswordReducer,
  signIn: signInReducer,
  availability: availabilityReducer,
  chat: chatReducer,
  cms: cmsReducer,
  communityauth: communityauthReducer,
  communityDetail: communityDetailReducer,
  dashboardMentor: dashboardMentorReducer,
  menteeDashboard: menteeDashboardReducer,
  menteeListing: menteeListingReducer,
  menteesLog: menteesLogReducer,
  menteesRequest: menteesRequestReducer,
  mentorDashboard1: mentorDashboard1Reducer,
  mentorIgnite: mentorIgniteReducer,
  mentors: mentorsReducer,
  myDiagnosticToolkit: myDiagnosticToolkitReducer,
  myWaitList: myWaitListReducer,
  organisation: organisationReducer,
  password: passwordReducer,
  pendingMenterRequest: pendingMenterRequestReducer,
  preregisterationForm: preregisterationFormReducer,
  program: programReducer,
  refer: referReducer,
  resourcesHub: resourcesHubReducer,
  newsletter: newsletterReducer,
  scheduleListingCalendar: scheduleListingCalendarReducer,
  certificate: certificateReducer,
  contactUs: contactUsReducer,
  deleteProfile: deleteProfileReducer,
  eventDetail: eventDetailReducer,
  events: eventsReducer,
  answer: answerReducer,
  question: questionReducer,
  reportAdmin: reportAdminReducer,
  reportUser: reportUserReducer,
  faq: faqReducer,
  page: pageReducer,
  updateProfile1: updateProfile1Reducer,
  updateProfile4: updateProfile4Reducer,
  updateProfileStep1: updateProfileStep1Reducer,
  myMentors: myMentorsReducer,
  home: homeReducer,

  forum: forumReducer,
  
  testimonials,
  ResourcesHubData,
  community,
  isFetching,
  faqData,
  userExperience,
  filter,
  redirectTo,
  userInfo,
  updateProfileData,
  userRegister,
  // certificateData,
  mentorsData,
  menteeRequestData,
  myWaitListData,
  categories,
  forums,
  forumusers,
  reportcategories,
  eventsData,
  NewsletterData,
  VideoData,
  programmes,
  categoryUserReducer,
  scheduleListingReducer,
  teams: teamsReducer,
  advisors: advisorsReducer
});

// Root reducer with logout handling
// Root reducer with logout handling
const rootReducer = (state, action) => {
  if (action.type === "LOG_OUT") {
    // If using redux-persist, remove persisted storage
    localStorage.removeItem("persist:root"); 
    state = undefined; // reset all slices
  }
  return appReducer(state, action);
};

export default rootReducer;